import { render, staticRenderFns } from "./EmployeePageCreateForm.vue?vue&type=template&id=1a2e8866&scoped=true&"
import script from "./EmployeePageCreateForm.vue?vue&type=script&lang=js&"
export * from "./EmployeePageCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e8866",
  null
  
)

export default component.exports